// extracted by mini-css-extract-plugin
export var videoContainer = "_jd-0";
export var videoIframe = "_jd-3";
export var videoLink = "_jd-1";
export var videoOverlay = "_jd-4";
export var videoOverlayText = "_jd-5";
export var videoWrapper = "_jd-2";